import type { TLAssetStore } from "@tldraw/tlschema";
import { MAX_IMAGE_SIZE, imageSize, taskQueue } from "../shared/images";
import { uploadFile } from "./api";
import { ImagePreviews } from "./image-previews";
export function createImageAssetStore(
  room: string,
  cloud = false,
): TLAssetStore & { previews: ImagePreviews } {
  const upload = taskQueue(2);
  const previews = new ImagePreviews();
  return {
    previews,
    upload: (_asset, file) =>
      upload(async () => {
        const result = await uploadFile(room, file, undefined, cloud);
        return {
          src: result.src,
          meta: result.image ? { imagePreviews: true } : {},
        };
      }),
    resolve: (asset, context) => {
      const src = asset.props.src;
      if (asset.type === "image" && !src) return previews.get(asset.id);
      if (
        asset.type !== "image" ||
        !src ||
        !asset.meta.imagePreviews ||
        context.shouldResolveToOriginal
      )
        return src;
      const native = Math.max(asset.props.w, asset.props.h),
        edge = native * context.steppedScreenScale * context.dpr;
      // Deep zoom must not decode every full-resolution source on the canvas:
      // only images on screen and drawn beyond the largest preview use originals.
      const onScreen = (context as { onScreen?: boolean }).onScreen === true;
      if (onScreen && edge > MAX_IMAGE_SIZE && native > MAX_IMAGE_SIZE)
        return src;
      return `${src}?size=${imageSize(edge)}`;
    },
  };
}
